export class DeviceInfoModel {
  deviceInfo: any;
  isMobile!: boolean;
  isTablet!: boolean;
  isDesktop!: boolean;
}
